/* eslint-disable import/prefer-default-export */

/**
 * Maps the contentful response for image content type to the view
 *
 * @param {Object} args
 * @param {Object} args.image
 * @param {String=} args.caption
 * @param {String=} args.url
 * @returns {Object}
 */
export const imageAdapter = ({ image, caption, url }) => {
  const imageUrl = image?.fields?.file?.url;
  // Matches URLs we should leave untouched: protocol-relative or absolute
  // (`//cdn...` / `https://...`) AND root-relative paths (`/assets/...`).
  // The previous regex (`/^(https?:)?\/\//`) missed the leading-single-slash
  // case, so root-relative CMS asset paths were incorrectly prefixed with
  // `https://`. The `|^\/` branch fixes that.
  const urlHasProtocol = /^(https?:)?\/\/|^\//.test(imageUrl);
  return {
    src: imageUrl
      ? `${urlHasProtocol ? '' : 'https://'}${imageUrl}`
      : undefined,
    alt: image?.fields?.description,
    caption,
    url,
  };
};
